import { Paper } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomEmptyView from "../../../Components/CustomEmptyView";
import PaginationComponent from "../../../Components/CustomPagination";
import DeleteConfirmationPopup from "../../../Components/DeleteConfirmationPopup";
import Loader from "../../../Components/Loader";
import TableTopView from "../../../Components/TableTopView";
import Strings from "../../../Config/Strings";
import { deleteProductCategoryDetailsAPI } from "../../../Store/Action/productCategory";
import ProductCategoryTableBody from "./Controls/ProductCategoryTableBody";
import ProductCategoryTableHeader from "./Controls/ProductCategoryTableHeader";
import Pagination from "../../../Components/Pagination";
import Colors from "../../../theme/Colors";

const CategoryTable = ({
  productCategory,
  rowsPerPage,
  handleChangePage,
  totalItems,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryIdToDelete, setCategoryIdToDelete] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  const handleOpen = useCallback(() => setModalVisible(true), []);
  const handleClose = useCallback(() => setModalVisible(false), []);
  const handleCancelDelete = useCallback(() => {
    setShowDeleteModal(false);
  }, []);

  const handleShowDeleteModal = useCallback((productCategoryId) => {
    setCategoryIdToDelete(productCategoryId);
    setShowDeleteModal(true);
  }, []);

  const onViewProductCategoryDetails = useCallback(
    (prodCategoryId) => {
      navigate(`/productCategory/${prodCategoryId?.product_category_id}`, {
        state: { prodCategoryId },
      });
    },
    [navigate]
  );

  const onEditProductCategoryDetails = useCallback(
    (editProdCategory) => {
      navigate(`/productCategory/edit`, { state: { editProdCategory } });
    },
    [navigate]
  );

  const handleDeleteUser = async () => {
    setLoading(true);
    try {
      await dispatch(
        deleteProductCategoryDetailsAPI(
          categoryIdToDelete,
          (isSuccess, response) => {
            setShowDeleteModal(false);
            setLoading(false);
            if (isSuccess?.status === true) {
              toast.success("Product Category Deleted Successfully");
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else {
              const errorMessage =
                response?.error?.message || Strings.somethingWentWrongError;
              toast.error(errorMessage);
            }
          }
        )
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ minWidth: "110%" }}>
            {productCategory?.length === 0 ||
            productCategory?.length === undefined ||
            productCategory?.length === null ? (
              <div style={{ width: "70vw" }}>
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <ProductCategoryTableHeader />
                  <ProductCategoryTableBody
                    prodCategoryDetails={productCategory}
                    onEditProductCategoryDetails={onEditProductCategoryDetails}
                    onViewProductCategoryDetails={onViewProductCategoryDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                  />
                </table>
              </>
            )}
          </div>

          {Array.isArray(productCategory) && productCategory.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryTable;

const mainContainer = {
  borderRadius: "10px",
  marginTop: "25px",
  marginLeft: "22px",
  width: "97%",
  height: "76vh", // Control height for scrolling
  display: "flex",
  flexDirection: "column",
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "auto", // Ensure vertical scroll
  overflowX: "scroll",
  flexGrow: 1, // Allow table to grow and pagination to stay at the bottom
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};
